const EmptyState = ({ icon, title = 'Nothing to show', message, action }) => (
  <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
    {icon && <span className="mb-1 text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">{icon}</span>}
    <h6 className="text-f-h6 font-semibold text-theme-headings dark:text-themedark-headings">{title}</h6>
    {message && (
      <p className="max-w-md text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">{message}</p>
    )}
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export default EmptyState;
